<template>
    <main class="auth_page">
        <section class="auth_hero">
            <button class="back_button" type="button" aria-label="返回" @click="$router.back()">
                <van-icon name="arrow-left" />
            </button>
            <div class="auth_mark"><van-icon name="service-o" /></div>
            <p class="eyebrow">WECHAT ACCOUNT LINK</p>
            <h1>登录并绑定微信</h1>
            <p>登录现有账号后，您可以提交售后工单并接收处理结果。</p>
        </section>

        <section class="auth_card">
            <van-field v-model.trim="name" label="姓名" maxlength="20" clearable placeholder="请输入注册时填写的姓名" />
            <van-field v-model.trim="passport" label="手机号" type="tel" maxlength="11" clearable placeholder="请输入账号手机号" />
            <button class="primary_button" type="button" :disabled="submitting" @click="login">
                <van-loading v-if="submitting" size="18" color="#fff" />
                <span v-else>登录并绑定微信</span>
            </button>
            <div class="register_link">
                <span>还没有系统账号？</span>
                <button type="button" :disabled="!canRegister" @click="toRegister">立即注册</button>
            </div>
            <div class="security_note">
                <van-icon name="shield-o" />
                <span>微信仅用于身份绑定与售后结果通知，不会公开您的账号信息。</span>
            </div>
        </section>
    </main>
</template>

<script>
import until from '@/api/until.js'
import noLoginApi from '@/api/teaching_studio_no_login.js'
import toolApi from '@/api/teaching_studio_tool.js'
import { finishWechatAuth, getSaleServiceReturn } from '@/utils/saleServiceAuth.js'

export default {
    name: 'Login',
    data() {
        return {
            salt: '',
            passport: '',
            name: '',
            canRegister: Boolean(getSaleServiceReturn()),
            submitting: false
        }
    },
    computed: {
        appId() {
            return this.$root.app_id || until.getParameter('app_id') || 'wx0154d46e98975549'
        }
    },
    mounted() {
        document.title = '登录并绑定微信'
        this.passport = String(this.$route.query.phone_number || '')
        this.name = String(this.$route.query.name || '')
        this.getSalt()
        this.getCouldRegister()
    },
    methods: {
        async getSalt() {
            const guid = until.getCookie('guid') || until.guid()
            if (!until.getCookie('guid')) until.setCookie('guid', guid)
            const res = await toolApi.ToolForm_saltGet({ computer_code: guid.substring(0, 6) })
            if (res && res.errcode === 0) this.salt = res.other
        },
        async getCouldRegister() {
            if (this.canRegister) return
            const res = await noLoginApi.Api_nologinWechatCouldSelf_createGet({ app_id: this.appId })
            this.canRegister = Boolean(res && res.errcode === 0 && res.other)
        },
        toRegister() {
            if (!this.canRegister) {
                this.$toast('当前公众号未开放自主注册')
                return
            }
            this.$router.push('/register').catch(() => {})
        },
        async login() {
            if (!this.name) return this.$toast('请输入姓名')
            if (!/^1\d{10}$/.test(this.passport)) return this.$toast('请输入正确的手机号')
            if (!this.salt) await this.getSalt()
            this.submitting = true
            const computerCode = (until.getCookie('guid') || '').substring(0, 6)
            const res = await noLoginApi.Api_nologinLoginWechat_platformLogin_passportPost({
                app_id: this.appId,
                computer_code: computerCode,
                passport: this.passport,
                name: this.name,
                salt: this.salt
            })
            this.submitting = false
            if (res && res.errcode === 0) {
                this.$toast.success('登录并绑定成功')
                finishWechatAuth(this.$router)
            } else {
                this.getSalt()
            }
        }
    }
}
</script>

<style scoped>
.auth_page { min-height: 100%; overflow-y: auto; background: #f5f8f7; color: #1f2937; }
.auth_hero { position: relative; min-height: 380px; padding: 68px 56px 118px; color: #fff; overflow: hidden; background: linear-gradient(145deg, #316fe5, #4e89ff 66%, #6b9dff); }
.auth_hero::after { content: ''; position: absolute; right: -120px; bottom: -155px; width: 330px; height: 330px; border: 52px solid rgba(255,255,255,.09); border-radius: 50%; }
.back_button { position: absolute; top: 28px; left: 28px; display: grid; width: 62px; height: 62px; place-items: center; border: 0; border-radius: 50%; color: #fff; background: rgba(255,255,255,.14); font-size: 30px; }
.auth_mark { display: grid; width: 78px; height: 78px; place-items: center; border: 1px solid rgba(255,255,255,.42); border-radius: 22px; background: rgba(255,255,255,.14); font-size: 40px; }
.eyebrow { margin-top: 32px; color: rgba(255,255,255,.72); font-size: 18px; font-weight: 700; letter-spacing: 2px; }
.auth_hero h1 { margin-top: 10px; font-size: 42px; line-height: 1.25; }
.auth_hero > p:last-child { max-width: 570px; margin-top: 14px; color: rgba(255,255,255,.8); font-size: 24px; line-height: 1.6; }
.auth_card { position: relative; z-index: 2; margin: -66px 28px 40px; padding: 38px 30px 34px; border: 1px solid #e8edf2; border-radius: 28px; background: #fff; box-shadow: 0 14px 38px rgba(31,41,55,.1); }
.auth_card ::v-deep .van-cell { min-height: 94px; margin-bottom: 18px; align-items: center; border-radius: 18px; background: #f7f9fc; font-size: 26px; }
.auth_card ::v-deep .van-field__label { width: 112px; color: #52647d; }
.primary_button { display: grid; width: 100%; min-height: 88px; margin-top: 28px; place-items: center; border: 0; border-radius: 999px; color: #fff; background: #4e89ff; box-shadow: 0 10px 20px rgba(78,137,255,.24); font-size: 28px; font-weight: 700; }
.primary_button:disabled { opacity: .65; }
.register_link { display: flex; margin-top: 30px; align-items: center; justify-content: center; gap: 12px; color: #7c8798; font-size: 23px; }
.register_link button { border: 0; color: #316fe5; background: transparent; font-size: 23px; font-weight: 700; }
.register_link button:disabled { color: #b4bbc5; }
.security_note { display: flex; margin-top: 30px; padding: 20px; align-items: flex-start; gap: 12px; border-radius: 16px; color: #60728a; background: #e8efff; font-size: 21px; line-height: 1.55; }
.security_note .van-icon { flex: 0 0 auto; color: #4e89ff; font-size: 28px; }
</style>
